<script setup>
import { computed } from 'vue'
import { useCartStore } from '../stores/cartStore'

const cartStore = useCartStore()

const stateFee = computed(() => {
  if (cartStore.products.length === 0) return undefined

  const product = cartStore.products.find((product) =>
    product.name.includes('State Filing Fee')
  )
  return product ? product : undefined
})

const ccProduct = computed(() => {
  if (cartStore.products.length === 0) return undefined
  return cartStore.products.filter(
    (product) => !product.name.includes('State Filing Fee')
  )[0]
})
</script>
<template>
  <div class="ps-lg-2 px-auto">
    <div class="card card-sm shadow-none mb-4 border">
      <div class="card-body">
        <div class="border-bottom pb-4 mb-4">
          <h3 class="card-header-title">Order summary</h3>
        </div>
        <!-- Product -->
        <div class="border-bottom pb-4 mb-4">
          <div class="d-flex">
            <div class="flex-shrink-0"></div>

            <div class="flex-grow-1">
              <dl class="row">
                <dt class="col-8">FL State Fee</dt>
                <dd class="col-4 text-sm-end mb-0 float-end">
                  ${{ stateFee.price / 100 }}
                </dd>
              </dl>
              <div class="d-grid">
                <div class="text-body">
                  <span class="small">Collected by the State of Florida </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Product -->

        <!-- Product -->
        <div class="border-bottom pb-4 mb-4">
          <div class="d-flex">
            <div class="flex-shrink-0"></div>

            <div class="flex-grow-1">
              <dl class="row">
                <dt class="col-8">{{ ccProduct.name }}</dt>
                <dd class="col-4 text-sm-end mb-0 float-end">
                  ${{ ccProduct.price / 100
                  }}<span
                    class="small"
                    v-if="ccProduct.name.includes('ComplianceClerk Pro')"
                    >/yr</span
                  >
                </dd>
              </dl>
              <div class="d-grid">
                <template v-if="ccProduct.name.includes('ComplianceClerk Pro')">
                  <div class="text-body text-primary mb-3">
                    <span class="small"
                      >File today and save on your Beneficial Ownership Report
                      (a new Federal requirement from FinCEN).</span
                    >
                  </div>
                  <div class="px-auto small">
                    <ul class="list-checked list-checked-soft-bg-primary">
                      <li class="list-checked-item">Annual Report</li>
                      <li class="list-checked-item">
                        Beneficial Ownership Report
                        <span class="badge bg-soft-primary text-primary">
                          Bonus - a $99 Value!</span
                        >
                      </li>
                      <li class="list-checked-item">
                        Avoid Penalties and Never Miss a Filing
                      </li>
                      <li class="list-checked-item">
                        No Upsells or Hidden Fees
                      </li>
                    </ul>
                  </div>
                </template>
                <template v-else>
                  <div class="text-body">
                    <span class="small">{{ ccProduct.description }}</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <!-- End Product -->
        <!-- Discount -->
        <div
          v-if="
            cartStore.discount.amount > 0 || cartStore.discount.percent_off > 0
          "
          class="border-bottom pb-4 mb-4"
        >
          <div class="d-flex">
            <div class="flex-shrink-0"></div>

            <div class="flex-grow-1">
              <dl class="row">
                <dt class="col-8">Discount</dt>
                <dd class="col-4 text-sm-end mb-0 float-end">
                  <template v-if="cartStore.discount.amount > 0">
                    (${{ cartStore.discount.amount / 100 }})
                  </template>
                  <template v-else-if="cartStore.discount.percent_off > 0">
                    {{ cartStore.discount.percent_off }}% off*
                  </template>
                </dd>
              </dl>
              <div class="d-grid">
                <div class="text-body">
                  <span class="small"
                    >{{ cartStore.discount.description }}
                  </span>
                  <template v-if="cartStore.discount.percent_off > 0">
                    <small style="font-style: italic; display: block"
                      >*% discounts do not apply to state fees</small
                    >
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Discount -->
        <div class="pb-4">
          <div class="d-grid">
            <dl class="row">
              <dt class="col-8">Due Today</dt>
              <dd class="col-4 text-sm-end mb-0">
                ${{ cartStore.totalPrice.toFixed(2) }}
              </dd>
            </dl>
            <!-- End Row -->
          </div>
        </div>
        <!-- End Product -->
      </div>
      <!-- End Card Body -->
    </div>
    <!-- End Card -->
  </div>
  <!-- End Col -->
</template>
